/**
 * function to set formatNumber based on this project standard
 * @param number
 * @returns {string}
 */
export const formatNumber = (number) =>{
    return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
    });
};

/**
 * Converts a 1-based WorkOrderSequence into a spreadsheet-style alpha suffix
 * 1 -> A, 2 -> B, ..., 26 -> Z, 27 -> AA, 28 -> AB, ...
 * @param sequence
 * @returns {string}
 */
export const sequenceToAlpha = (sequence) => {
    let n = Number(sequence);
    if (!n || n < 1) return "";

    let result = "";
    while (n > 0) {
        const remainder = (n - 1) % 26;
        result = String.fromCharCode(65 + remainder) + result;
        n = Math.floor((n - 1) / 26);
    }

    return result;
};

/**
 * Formats a currency value with K/M magnitude suffixes for compact Dashboard tile display.
 * <1,000: whole number, no suffix. >=1,000 and <1,000,000: value/1,000 to 1 decimal place + "K".
 * >=1,000,000: value/1,000,000 to 3 decimal places + "M".
 * @param value
 * @param withSymbol
 * @param hideNegativeSign omit the leading "-" for negative values (e.g. when the value is already styled red)
 * @returns {string}
 */
export const formatCurrencyKM = (value, withSymbol = true, hideNegativeSign = false) => {
    if (value === null || value === undefined) return "—";
    const num = Number(value);
    const symbol = withSymbol ? "$" : "";
    const sign = num < 0 && !hideNegativeSign ? "-" : "";
    const abs = Math.abs(num);

    if (abs < 1000) {
        return `${sign}${symbol}${Math.round(abs).toLocaleString("en-AU")}`;
    }
    if (abs < 1000000) {
        return `${sign}${symbol}${(abs / 1000).toFixed(1)}K`;
    }
    return `${sign}${symbol}${(abs / 1000000).toFixed(3)}M`;
};